/**
 *
 * Asynchronously loads the component for UserManagement
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
